import { render, staticRenderFns } from "./distance.vue?vue&type=template&id=38d0b7b7&"
import script from "./distance.vue?vue&type=script&lang=js&"
export * from "./distance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports